import { useCallback } from "react";

import { AxiosRequestConfig } from "axios";
import useAxios from "axios-hooks";

import { RequestPayload, CapturePaymentsType } from "hooks/index.types";
import { capturePayments } from "utils/apiConfig";
import { userNotification } from "utils/helperFunctions";

export const useCapturePayments = () => {
  // ==============================|| API ||============================== //

  // API call to capture payment from third-party payment methods
  const [{ data, loading, error }, paymentCaptureAPICall] = useAxios(
    capturePayments(),
    { manual: true }
  );

  // ==============================|| handler functions ||============================== //

  // function to call capture payment API
  const callCapturePaymentAPI = useCallback(
    async (
      config: AxiosRequestConfig
    ): Promise<RequestPayload<CapturePaymentsType> | null> => {
      try {
        // API call to capture payment
        const result = await paymentCaptureAPICall(config);

        // verify API response
        if (result?.data?.status === 1) {
          return result;
        }

        userNotification(result?.data?.message || "Failed to capture payment!");

        return null;
      } catch (error) {
        userNotification("Failed to capture payment!");

        return null;
      }
    },
    [paymentCaptureAPICall]
  );

  return {
    getPaymentCaptureData: data,
    getPaymentCaptureLoading: loading,
    paymentCaptureError: error,
    paymentCaptureAPICall: callCapturePaymentAPI,
  };
};
